<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="mx-auto">
      <v-data-table
        :headers="headers"
        :items="news"
        :page="page"
        :pageCount="numberOfPages"
        :items-per-page="itemsPerPage"
        class="elevation-2 striped"
        v-model="selectedRows"
        @fileUploaded="fileUploaded"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
          'items-per-page-text': `${perPageText}`,
        }"
        :loading="loadTable"
        :loading-text="$t('common.loadingText')"
      >
        <template v-slot:[`body.prepend`]>
          <tr>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="newsTitle"
                type="text"
                :label="$t('_news.title')"
              ></v-text-field>
            </td>
            <td class="d-inline-block d-sm-table-cell">
              <v-text-field
                v-model="newsContent"
                type="text"
                :label="$t('_news.content')"
              ></v-text-field>
            </td>
          </tr>
        </template>
        <template v-slot:item="{ item }">
          <tr
            :style="{ 'background-color': rowColor(item) }"
            @click="rowClick(item)"
          >
            <td>{{ item.title }}</td>
            <td>{{ item.content }}</td>
            <td>{{ item.dateTable }}</td>
            <!-- <td>{{ item.assets }}</td> -->
            <td style="width: 220px" align="right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon
                      small
                      @click="onUploadButtonClick(item)"
                      color="orange"
                    >
                      file_upload
                    </v-icon>
                    <!-- accept="application/xml, application/zip" -->
                    <input
                      ref="uploader"
                      class="d-none"
                      type="file"
                      multiple
                      @change="onFileChanged(selectedItem)"
                  /></v-btn>
                </template>
                <span>{{ $t("actions.uploadPhoto") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon small @click="itemPhoto(item)" color="blue">
                      photo_camera
                    </v-icon></v-btn
                  >
                </template>
                <span>{{ $t("actions.showPhoto") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon small @click="editItem(item)" color="green">
                      mdi-pencil
                    </v-icon></v-btn
                  >
                </template>
                <span>{{ $t("actions.edit") }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon small @click="deleteItem(item)" color="error">
                      mdi-delete
                    </v-icon></v-btn
                  >
                </template>
                <span>{{ $t("actions.delete") }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon
                      small
                      v-if="!item.isArchived"
                      @click="archiveItem(item)"
                      color="purple"
                    >
                      mdi-archive-plus
                    </v-icon>
                    <v-icon
                      small
                      v-else
                      @click="unarchiveItem(item)"
                      color="purple"
                    >
                      mdi-archive-cancel
                    </v-icon></v-btn
                  >
                </template>
                <span v-if="!item.isArchived">{{ $t("actions.archive") }}</span>
                <span v-else>{{ $t("actions.unarchive") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-card-text>{{ $t("common.dataNotFound") }}</v-card-text>
        </template>
      </v-data-table>

      <new-news-button
        :dialog.sync="dialog"
        :editedItem="editedItem"
        :editedIndex="editedIndex"
        @confirmed="onConfirmed"
        @cancelled="onCancelled"
      />
    </v-card>

    <v-dialog
      width="1000"
      :retain-focus="false"
      v-model="showPhoto"
      v-if="selectedItem != null && selectedItem.assetList.length != 0"
    >
      <v-card max-width="1000" dark>
        <v-card-title
          >{{ selectedItem.title }}
          <v-spacer></v-spacer>
          <v-btn right small color="error" dark @click="deletePhoto()">
            <v-icon dark left>delete</v-icon>
            {{ "FOTOĞRAFI SİL" }}
          </v-btn>
        </v-card-title>
        <v-carousel show-arrows-on-hover v-model="currentIndex" height="500">
          <v-carousel-item
            v-for="(asset, i) in selectedItem.assetList"
            :key="i"
          >
            <v-img :src="asset.assetUrl" contain max-height="450" />
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import NewNewsButton from "./NewNewsButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { NewNewsButton },
  props: {
    groupId: String,
    filter: Object,
    newsItems: Array,
  },
  data() {
    return {
      editedIndex: -1,
      editedItem: {
        incidentType: {
          id: "",
          name: "",
        },
        description: "",
        countyCode: null,
        neighborhoodCode: "",
        lat: "",
        lon: "",
      },
      newsTitle: "",
      newsContent: "",
      date: "",
      city: "",
      assets: [],
      categories: [],
      totalCount: 0,
      page: 0,
      numberOfPages: 5,
      itemsPerPage: 5,
      totalItemsPerPage: 10000,
      options: {},
      selectedRows: [],
      dialog: false,
      showPhoto: false,
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: "",
      y: "",
      timeout: 3000,
      currentIndex: -1,
      loadTable: true,
      overlay: true,
      mode: "",
      selectedItem: null,
    };
  },
  async created() {
    console.log("news are refreshing due to creating");
    await this.refreshTable();
  },
  computed: {
    ...mapGetters({ dark: "app/dark" }),
    ...mapGetters({ items: "news/items" }),
    ...mapGetters({ language: "app/language" }),
    headers() {
      return [
        {
          text: this.$t("_news.title"),
          sortable: true,
          value: "title",
        },
        {
          text: this.$t("_news.content"),
          sortable: false,
          value: "content",
        },
        {
          text: this.$t("_news.date"),
          sortable: true,
          value: "date",
          divider: true,
        },
        // {
        //   text: this.$t("_news.assets"),
        //   sortable: false,
        //   value: "assets",
        // },
        {
          text: this.$t("_news.actions"),
          value: "actions",
          sortable: false,
          align: "right",
          divider: false,
          width: "200px",
        },
      ];
    },
    perPageText() {
      if (this.language == "en_US") {
        return "Rows per page:";
      }
      return "Sayfa başına satır:";
    },
    news() {
      let conditions = [];

      if (this.newsTitle) {
        conditions.push(this.filterNewsTitle);
      }
      if (this.newsContent) {
        conditions.push(this.filterNewsContent);
      }
      if (this.date) {
        conditions.push(this.filterDate);
      }

      if (conditions.length > 0) {
        return this.newsItems.filter((item) => {
          return conditions.every((condition) => {
            return condition(item);
          });
        });
      }
      return this.newsItems;
    },
  },
  methods: {
    ...mapActions(["news/getItems"]),
    ...mapActions({
      removeNews: "news/remove",
      uploadAsset: "news/uploadNewsAsset",
      removeAsset: "news/removeNewsAsset",
      archive: "news/archiveNews",
      unarchive: "news/unarchiveNews",
    }),
    filterNewsTitle(item) {
      console.log(item.title);
      return item.title.toLowerCase().includes(this.newsTitle.toLowerCase());
    },
    filterNewsContent(item) {
      return item.content
        .toLowerCase()
        .includes(this.newsContent.toLowerCase());
    },
    async refreshTable() {
      console.log("Refreshed in NewsTable");
      let filterr = JSON.parse(JSON.stringify(this.filter));
      await this.$store.dispatch("news/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        filter: filterr,
      });
      this.overlay = false;
      this.loadTable = false;
    },
    rowColor(item) {
      if (this.selectedRows.indexOf(item.id) > -1) {
        return "#82DAC0";
      } else if (item.isArchived) {
        return "#999796";
      } else {
        return this.dark ? "#1E1E1E" : "white";
      }
    },
    async archiveItem(item) {
      console.log(item);
      await this.archive(item.id);
      this.refreshTable();
    },
    async unarchiveItem(item) {
      console.log(item);
      await this.unarchive(item.id);
      this.refreshTable();
    },
    fileUploaded() {
      // hide a dialog
      this.refreshTable();
      // save a user and refresh a table
    },
    async deleteItem(item) {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Haberi silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#ff7674",
          cancelButtonColor: "#41b882",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeNews({
                item: item,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Haber silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Haber silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    async deletePhoto() {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Fotoğrafı silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          cancelButtonColor: "#41b882",
          confirmButtonColor: "#ff7674",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeAsset({
                newsId: self.selectedItem.id,
                assetId: self.selectedItem.assetList[self.currentIndex].id,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Kayıt silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
              self.showPhoto = false;
              self.selectedItem.assetList.splice(self.currentIndex, 1);
              self.showPhoto = true;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Kayıt silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    async editItem(item) {
      console.log(item);
      this.editedIndex = this.news.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.date = new Date(
        item.date.getTime() - item.date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(0, 10);
      this.editedItem.time = new Date(
        item.date.getTime() - item.date.getTimezoneOffset() * 60000
      )
        .toISOString()
        .substring(11, 16);

      this.editedItem.title = item.title;
      this.editedItem.content = item.content;
      this.editedItem.id = item.id;

      console.log(this.editedItem);
      this.dialog = true;
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      this.refreshTable();
      //this.$emit("fileUploaded");
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    rowClick(item, row) {
      console.log("row clicked");
      console.log(item.id);
      // row.select(true);
      this.selectedId = item.name;
      this.toggleSelection(item);
      console.log("rowclickkkk");
    },
    toggleSelection(item) {
      if (this.selectedRows.includes(item.id)) {
        console.log(this.selectedRows);
        this.selectedRows = this.selectedRows.filter(
          (selectedKeyID) => selectedKeyID !== item.id
        );
        this.$emit("placeReClick");
      } else if (this.selectedRows.length == 0) {
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      } else if (
        !this.selectedRows.includes(item.id) &&
        this.selectedRows.length == 1
      ) {
        this.selectedRows.pop();
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      }
    },
    itemPhoto(item) {
      console.log("photoitem", item);
      this.selectedItem = { ...item };
      console.log(this.selectedItem);
      if (this.selectedItem.assetList.length == 0) {
        this.snackbar = true;
        this.snackColor = "warning";
        this.snackText = "Fotoğraf bulunamadı!";
        this.y = "bottom";
        this.x = "right";
        this.mode = "multi-line";
      }
      this.showPhoto = true;
    },
    onUploadButtonClick(item) {
      this.selectedItem = { ...item };
      this.$refs.uploader.click();
    },
    async onFileChanged(item) {
      let files = this.$refs.uploader.files;
      //let files = e.target.files;
      console.log(files);
      for (let file of files) {
        console.log(file);
        console.log(file.type.split("/")[0]);

        if (
          file.type.split("/")[0] === "image" &&
          file.name.length > 2
          //&& file.size < 150000
        ) {
          console.log(file);
          console.log(item.id);
          try {
            await this.uploadAsset({
              id: item.id,
              file: file,
            });
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Fotoğraf yüklendi!";
            this.y = "bottom";
            this.x = "right";
            this.mode = "multi-line";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Fotoğraf yüklenemedi!";
            this.y = "bottom";
            this.x = "right";
            this.mode = "multi-line";
            console.error(e);
          }
        } else {
          console.log("invalid file.");
          this.snackbar = true;
          this.snackColor = "error";
          this.snackText = "Dosya formatı geçersiz!";
          this.y = "bottom";
          this.x = "right";
          this.mode = "multi-line";
        }

        //let file = files[i];
      }
      this.$refs.uploader.value = "";
      this.refreshTable();
    },
  },

  watch: {
    groupId() {
      this.$emit("update:groupId", this.groupId);
      this.refreshTable();
    },
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    language: function () {
      console.log("lang changed");
      this.refreshTable();
    },
    filter: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    news(newVal, oldVal) {
      console.log("OldVal", oldVal);
      console.log("NewVal", newVal);
    },
  },
};
</script>
